import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/menu/guidelines', { params });
  },
  detail(id) {
    return axios.get(`/v1/menu/guidelines/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/menu/guidelines/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/menu/guidelines', data);
  },
  delete(id) {
    return axios.delete(`/v1/menu/guidelines/${id}`);
  }
};
